module.exports = __webpack_public_path__ + "static/mckinsey_950-b7047755ebc308bc6a996ae2bd122b9e.jpg";